import { Stack, Tab, Tabs, Typography } from '@mui/material'

interface SvgIconProps {
  fill: string
}

const FloorplansSvg: React.FC<SvgIconProps> = ({ fill }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
  >
    <g clipPath='url(#clip0_2228_675)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.9937 3.78656H2.00058C1.73555 3.78656 1.48137 3.8863 1.29396 4.06385C1.10655 4.24139 1.00127 4.48219 1.00127 4.73328V12.307L3.64545 10.0784C3.72713 10.0014 3.83443 9.95339 3.94918 9.94269C4.06392 9.93199 4.17904 9.95922 4.27502 10.0198L6.93319 11.6983L10.6406 8.18596C10.7147 8.11569 10.8103 8.06928 10.9138 8.05331C11.0173 8.03734 11.1234 8.05261 11.2172 8.09697L12.993 9.94023V4.73328C12.993 4.48219 12.8877 4.24139 12.7003 4.06385C12.5129 3.8863 12.2587 3.78656 11.9937 3.78656ZM2.00058 2.83984C1.47051 2.83984 0.962152 3.03933 0.587337 3.39442C0.212522 3.74951 0.00195313 4.23111 0.00195312 4.73328V12.307C0.00195313 12.8092 0.212522 13.2908 0.587337 13.6459C0.962152 14.001 1.47051 14.2005 2.00058 14.2005H11.9937C12.5238 14.2005 13.0321 14.001 13.407 13.6459C13.7818 13.2908 13.9923 12.8092 13.9923 12.307V4.73328C13.9923 4.23111 13.7818 3.74951 13.407 3.39442C13.0321 3.03933 12.5238 2.83984 11.9937 2.83984H2.00058ZM5.99783 7.10007C5.99783 7.28656 5.95906 7.47122 5.88373 7.64351C5.8084 7.8158 5.69799 7.97235 5.55879 8.10422C5.4196 8.23609 5.25436 8.34069 5.07249 8.41205C4.89063 8.48342 4.69571 8.52015 4.49886 8.52015C4.30202 8.52015 4.1071 8.48342 3.92523 8.41205C3.74337 8.34069 3.57812 8.23609 3.43893 8.10422C3.29974 7.97235 3.18933 7.8158 3.114 7.64351C3.03866 7.47122 2.99989 7.28656 2.99989 7.10007C2.99989 6.72345 3.15782 6.36224 3.43893 6.09593C3.72004 5.82961 4.10131 5.68 4.49886 5.68C4.89641 5.68 5.27768 5.82961 5.55879 6.09593C5.83991 6.36224 5.99783 6.72345 5.99783 7.10007Z'
        fill={fill}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.99765 1.89301H13.9908C14.2558 1.89301 14.51 1.99275 14.6974 2.17029C14.8848 2.34784 14.9901 2.58864 14.9901 2.83972V10.4135C14.9901 10.6646 14.8848 10.9054 14.6974 11.0829C14.51 11.2604 14.2558 11.3602 13.9908 11.3602V12.3069C14.5209 12.3069 15.0292 12.1074 15.404 11.7523C15.7788 11.3972 15.9894 10.9156 15.9894 10.4135V2.83972C15.9894 2.33755 15.7788 1.85595 15.404 1.50086C15.0292 1.14578 14.5209 0.946289 13.9908 0.946289H3.99765C3.46758 0.946289 2.95922 1.14578 2.58441 1.50086C2.20959 1.85595 1.99902 2.33755 1.99902 2.83972H2.99834C2.99834 2.58864 3.10362 2.34784 3.29103 2.17029C3.47844 1.99275 3.73262 1.89301 3.99765 1.89301Z'
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id='clip0_2228_675'>
        <rect width='15.989' height='15.1475' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

const ElevationsSvg: React.FC<SvgIconProps> = ({ fill }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
  >
    <g clipPath='url(#clip0_2228_675)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.9937 3.78656H2.00058C1.73555 3.78656 1.48137 3.8863 1.29396 4.06385C1.10655 4.24139 1.00127 4.48219 1.00127 4.73328V12.307L3.64545 10.0784C3.72713 10.0014 3.83443 9.95339 3.94918 9.94269C4.06392 9.93199 4.17904 9.95922 4.27502 10.0198L6.93319 11.6983L10.6406 8.18596C10.7147 8.11569 10.8103 8.06928 10.9138 8.05331C11.0173 8.03734 11.1234 8.05261 11.2172 8.09697L12.993 9.94023V4.73328C12.993 4.48219 12.8877 4.24139 12.7003 4.06385C12.5129 3.8863 12.2587 3.78656 11.9937 3.78656ZM2.00058 2.83984C1.47051 2.83984 0.962152 3.03933 0.587337 3.39442C0.212522 3.74951 0.00195313 4.23111 0.00195312 4.73328V12.307C0.00195313 12.8092 0.212522 13.2908 0.587337 13.6459C0.962152 14.001 1.47051 14.2005 2.00058 14.2005H11.9937C12.5238 14.2005 13.0321 14.001 13.407 13.6459C13.7818 13.2908 13.9923 12.8092 13.9923 12.307V4.73328C13.9923 4.23111 13.7818 3.74951 13.407 3.39442C13.0321 3.03933 12.5238 2.83984 11.9937 2.83984H2.00058ZM5.99783 7.10007C5.99783 7.28656 5.95906 7.47122 5.88373 7.64351C5.8084 7.8158 5.69799 7.97235 5.55879 8.10422C5.4196 8.23609 5.25436 8.34069 5.07249 8.41205C4.89063 8.48342 4.69571 8.52015 4.49886 8.52015C4.30202 8.52015 4.1071 8.48342 3.92523 8.41205C3.74337 8.34069 3.57812 8.23609 3.43893 8.10422C3.29974 7.97235 3.18933 7.8158 3.114 7.64351C3.03866 7.47122 2.99989 7.28656 2.99989 7.10007C2.99989 6.72345 3.15782 6.36224 3.43893 6.09593C3.72004 5.82961 4.10131 5.68 4.49886 5.68C4.89641 5.68 5.27768 5.82961 5.55879 6.09593C5.83991 6.36224 5.99783 6.72345 5.99783 7.10007Z'
        fill={fill}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.99765 1.89301H13.9908C14.2558 1.89301 14.51 1.99275 14.6974 2.17029C14.8848 2.34784 14.9901 2.58864 14.9901 2.83972V10.4135C14.9901 10.6646 14.8848 10.9054 14.6974 11.0829C14.51 11.2604 14.2558 11.3602 13.9908 11.3602V12.3069C14.5209 12.3069 15.0292 12.1074 15.404 11.7523C15.7788 11.3972 15.9894 10.9156 15.9894 10.4135V2.83972C15.9894 2.33755 15.7788 1.85595 15.404 1.50086C15.0292 1.14578 14.5209 0.946289 13.9908 0.946289H3.99765C3.46758 0.946289 2.95922 1.14578 2.58441 1.50086C2.20959 1.85595 1.99902 2.33755 1.99902 2.83972H2.99834C2.99834 2.58864 3.10362 2.34784 3.29103 2.17029C3.47844 1.99275 3.73262 1.89301 3.99765 1.89301Z'
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id='clip0_2228_675'>
        <rect width='15.989' height='15.1475' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

const SurveySvg: React.FC<SvgIconProps> = ({ fill }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='18'
    viewBox='0 0 16 18'
    fill='none'
  >
    <path
      d='M3.19818 0.7545H13.857C14.4145 0.7545 14.9491 0.975948 15.3433 1.37013C15.7375 1.76431 15.9589 2.29893 15.9589 2.85638V15.647C15.9589 16.2045 15.7375 16.7391 15.3433 17.1333C14.9491 17.5275 14.4145 17.7489 13.857 17.7489H3.19818C2.64073 17.7489 2.1061 17.5275 1.71192 17.1333C1.31774 16.7391 1.0963 16.2045 1.0963 15.647V14.611H2.1024V15.647C2.1024 15.9376 2.21785 16.2164 2.42335 16.4219C2.62885 16.6274 2.90756 16.7428 3.19818 16.7428H13.857C14.1477 16.7428 14.4264 16.6274 14.6319 16.4219C14.8374 16.2164 14.9528 15.9376 14.9528 15.647V2.85638C14.9528 2.56576 14.8374 2.28705 14.6319 2.08155C14.4264 1.87605 14.1477 1.76061 13.857 1.76061H3.19818C2.90756 1.76061 2.62885 1.87605 2.42335 2.08155C2.21785 2.28705 2.1024 2.56576 2.1024 2.85638V3.89238H1.0963V2.85638C1.0963 2.29893 1.31774 1.76431 1.71192 1.37013C2.1061 0.975948 2.64073 0.7545 3.19818 0.7545Z'
      fill={fill}
      stroke={fill}
      strokeWidth='0.059781'
    />
    <path
      d='M1.06589 6.08308H1.09578V6.05319V5.52025C1.09578 5.38683 1.14878 5.25888 1.24312 5.16454C1.33746 5.0702 1.46541 5.0172 1.59883 5.0172C1.73225 5.0172 1.8602 5.0702 1.95454 5.16454C2.04888 5.25888 2.10188 5.38683 2.10188 5.52025V6.05319V6.08308H2.13177H2.66472C2.79814 6.08308 2.92609 6.13608 3.02043 6.23042C3.11477 6.32476 3.16777 6.45272 3.16777 6.58613C3.16777 6.71955 3.11477 6.84751 3.02043 6.94185C2.92609 7.03619 2.79814 7.08919 2.66472 7.08919H0.532943C0.399525 7.08919 0.271572 7.03619 0.177231 6.94185C0.0828905 6.84751 0.0298905 6.71955 0.0298905 6.58613C0.0298905 6.45272 0.0828905 6.32476 0.177231 6.23042C0.271572 6.13608 0.399526 6.08308 0.532943 6.08308H1.06589ZM1.06589 9.28074H1.09578V9.25085V8.71791C1.09578 8.58449 1.14878 8.45654 1.24312 8.3622C1.33746 8.26786 1.46541 8.21486 1.59883 8.21486C1.73225 8.21486 1.8602 8.26786 1.95454 8.3622C2.04888 8.45654 2.10188 8.58449 2.10188 8.71791V9.25085V9.28074H2.13177H2.66472C2.79814 9.28074 2.92609 9.33374 3.02043 9.42808C3.11477 9.52242 3.16777 9.65038 3.16777 9.78379C3.16777 9.91721 3.11477 10.0452 3.02043 10.1395C2.92609 10.2338 2.79814 10.2868 2.66472 10.2868H0.532943C0.399525 10.2868 0.271572 10.2338 0.177231 10.1395C0.0828906 10.0452 0.0298905 9.91721 0.0298905 9.78379C0.0298905 9.65038 0.0828905 9.52242 0.177231 9.42808C0.271572 9.33374 0.399525 9.28074 0.532943 9.28074H1.06589ZM1.06589 12.4784H1.09578V12.4485V11.9156C1.09578 11.7821 1.14878 11.6542 1.24312 11.5599C1.33746 11.4655 1.46541 11.4125 1.59883 11.4125C1.73225 11.4125 1.8602 11.4655 1.95454 11.5599C2.04888 11.6542 2.10188 11.7821 2.10188 11.9156V12.4485V12.4784H2.13177H2.66472C2.79814 12.4784 2.92609 12.5314 3.02043 12.6257C3.11477 12.7201 3.16777 12.848 3.16777 12.9815C3.16777 13.1149 3.11477 13.2428 3.02043 13.3372C2.92609 13.4315 2.79814 13.4845 2.66472 13.4845H0.532943C0.399525 13.4845 0.271572 13.4315 0.177231 13.3372C0.0828906 13.2428 0.0298905 13.1149 0.0298905 12.9815C0.0298905 12.848 0.0828906 12.7201 0.177231 12.6257C0.271572 12.5314 0.399525 12.4784 0.532943 12.4784H1.06589Z'
      fill={fill}
      stroke={fill}
      strokeWidth='0.059781'
    />
    <line
      x1='4.97461'
      y1='4.74077'
      x2='12.7911'
      y2='4.74077'
      stroke={fill}
      strokeWidth='1.91299'
    />
    <line
      x1='4.97461'
      y1='7.58257'
      x2='12.7911'
      y2='7.58257'
      stroke={fill}
      strokeWidth='1.91299'
    />
    <line
      x1='4.97461'
      y1='10.4253'
      x2='12.7911'
      y2='10.4253'
      stroke={fill}
      strokeWidth='1.91299'
    />
    <line
      x1='4.97461'
      y1='13.2681'
      x2='10.6593'
      y2='13.2681'
      stroke={fill}
      strokeWidth='1.91299'
    />
  </svg>
)

const GeoReportSvg: React.FC<SvgIconProps> = ({ fill }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
  >
    <g clipPath='url(#clip0_2228_685)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.99863 1.16547H13.9904C14.2554 1.16547 14.5096 1.26521 14.697 1.44275C14.8844 1.6203 14.9897 1.8611 14.9897 2.11219V13.4728C14.9897 13.7239 14.8844 13.9647 14.697 14.1422C14.5096 14.3198 14.2554 14.4195 13.9904 14.4195H1.99863C1.73359 14.4195 1.47941 14.3198 1.29201 14.1422C1.1046 13.9647 0.999313 13.7239 0.999313 13.4728V2.11219C0.999313 1.8611 1.1046 1.6203 1.29201 1.44275C1.47941 1.26521 1.73359 1.16547 1.99863 1.16547ZM13.9904 0.21875C14.5205 0.21875 15.0288 0.418236 15.4036 0.773324C15.7784 1.12841 15.989 1.61002 15.989 2.11219V13.4728C15.989 13.975 15.7784 14.4566 15.4036 14.8117C15.0288 15.1667 14.5205 15.3662 13.9904 15.3662H1.99863C1.46856 15.3662 0.960199 15.1667 0.585384 14.8117C0.210569 14.4566 0 13.975 0 13.4728V2.11219C0 1.61002 0.210569 1.12841 0.585384 0.773324C0.960199 0.418236 1.46856 0.21875 1.99863 0.21875L13.9904 0.21875Z'
        fill={fill}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.99638 14.4191V1.16504H3.99707V14.4191H4.99638ZM12.9909 3.53183C12.9909 3.40629 12.9382 3.28589 12.8445 3.19712C12.7508 3.10835 12.6237 3.05847 12.4912 3.05847H7.49467C7.36215 3.05847 7.23506 3.10835 7.14136 3.19712C7.04765 3.28589 6.99501 3.40629 6.99501 3.53183C6.99501 3.65738 7.04765 3.77778 7.14136 3.86655C7.23506 3.95532 7.36215 4.00519 7.49467 4.00519H12.4912C12.6237 4.00519 12.7508 3.95532 12.8445 3.86655C12.9382 3.77778 12.9909 3.65738 12.9909 3.53183ZM12.9909 6.37199C12.9909 6.24644 12.9382 6.12604 12.8445 6.03727C12.7508 5.9485 12.6237 5.89863 12.4912 5.89863H7.49467C7.36215 5.89863 7.23506 5.9485 7.14136 6.03727C7.04765 6.12604 6.99501 6.24644 6.99501 6.37199C6.99501 6.49753 7.04765 6.61793 7.14136 6.7067C7.23506 6.79547 7.36215 6.84535 7.49467 6.84535H12.4912C12.6237 6.84535 12.7508 6.79547 12.8445 6.7067C12.9382 6.61793 12.9909 6.49753 12.9909 6.37199ZM12.9909 9.21214C12.9909 9.0866 12.9382 8.9662 12.8445 8.87742C12.7508 8.78865 12.6237 8.73878 12.4912 8.73878H7.49467C7.36215 8.73878 7.23506 8.78865 7.14136 8.87742C7.04765 8.9662 6.99501 9.0866 6.99501 9.21214C6.99501 9.33768 7.04765 9.45808 7.14136 9.54685C7.23506 9.63563 7.36215 9.6855 7.49467 9.6855H12.4912C12.6237 9.6855 12.7508 9.63563 12.8445 9.54685C12.9382 9.45808 12.9909 9.33768 12.9909 9.21214ZM12.9909 12.0523C12.9909 11.9268 12.9382 11.8063 12.8445 11.7176C12.7508 11.6288 12.6237 11.5789 12.4912 11.5789H7.49467C7.36215 11.5789 7.23506 11.6288 7.14136 11.7176C7.04765 11.8063 6.99501 11.9268 6.99501 12.0523C6.99501 12.1778 7.04765 12.2982 7.14136 12.387C7.23506 12.4758 7.36215 12.5257 7.49467 12.5257H12.4912C12.6237 12.5257 12.7508 12.4758 12.8445 12.387C12.9382 12.2982 12.9909 12.1778 12.9909 12.0523Z'
        fill={fill}
      />
    </g>
    <rect
      x='0.478248'
      y='0.696998'
      width='15.0325'
      height='14.191'
      rx='1.65362'
      stroke={fill}
      strokeWidth='0.956495'
    />
    <defs>
      <clipPath id='clip0_2228_685'>
        <rect
          y='0.21875'
          width='15.989'
          height='15.1475'
          rx='2.13187'
          fill='white'
        />
      </clipPath>
    </defs>
  </svg>
)

const TabComponent = (props: any) => {
  const { selectedTabIndex, handleChange } = props

  const tabs = [
    {
      label: 'Floorplans',
      svg: FloorplansSvg,
    },
    {
      label: 'Elevations',
      svg: ElevationsSvg,
    },
    {
      label: 'Survey',
      svg: SurveySvg,
    },
    {
      label: 'Geo Report',
      svg: GeoReportSvg,
    },
  ]

  return (
    <Stack sx={{ width: '100%' }}>
      <Stack direction={'column'} sx={{ gap: 4 }}>
        <Typography
          sx={{
            alignItems: 'start',
            display: 'flex',
            color: '#04002E',
            fontSize: '16px',
            lineHeight: 'normal',
          }}
        >
          Confirm Selection
        </Typography>
        <Tabs
          value={selectedTabIndex}
          onChange={handleChange}
          orientation='vertical'
          sx={{
            alignItems: 'start',
            '.MuiTabs-indicator': {
              left: 0,
            },
          }}
        >
          {tabs.map((tab, index) => (
            <Tab
              disableRipple
              key={index}
              icon={
                <tab.svg
                  fill={index === selectedTabIndex ? '#1705E5' : '#97999B'}
                />
              }
              iconPosition='start'
              label={tab.label}
              sx={{
                width: '100%',
                alignItems: 'start',
                textTransform: 'capitalize',
                color: '#04002E',
                fontSize: '14px',
                display: 'flex',
                justifyContent: 'flex-start',
                minHeight: '44px',
                gap: '6px',
              }}
            />
          ))}
        </Tabs>
      </Stack>
    </Stack>
  )
}

export default TabComponent
